import * as types from './types';

const setOriginInput = (data) => ({
    type: types.SET_ORIGIN_INPUT,
    payload: data,
});

const setDestinationInput = (data) => ({
    type: types.SET_DESTINATION_INPUT,
    payload: data,
});

const setOriginPlaceId = (data) => ({
    type: types.SET_ORIGIN_PLACE_ID,
    payload: data,
});

const setDestinationPlaceId = (data) => ({
    type: types.SET_DESTINATION_PLACE_ID,
    payload: data,
});

const setPassengersInput = (data) => ({
    type: types.SET_PASSENGERS_INPUT,
    payload: data,
});

export {
    setDestinationInput,
    setDestinationPlaceId,
    setOriginInput,
    setOriginPlaceId,
    setPassengersInput,
};
